import { useCallback } from 'react';
import type { BffShoppingCart } from '@/core/models/bff-shopping-carts';
import { MAX_AMOUNT_OF_FRAMES_PER_ORDER } from '@/core/constants/order-limits';
import { matchesFrameProductId } from '@/core/constants/product-ids';

const useFrameQuantityLimit = (
  cart: BffShoppingCart | undefined,
  frameCatalogProductId?: string,
) => {
  const getCurrentFrameQuantity = useCallback(() => {
    const frame = cart?.products.find(p =>
      matchesFrameProductId(p.id, frameCatalogProductId),
    );
    return frame?.quantity ?? 0;
  }, [cart?.products, frameCatalogProductId]);

  const canAddFrames = useCallback(
    (quantity = 1) => {
      const currentQuantity = getCurrentFrameQuantity();
      return currentQuantity + quantity <= MAX_AMOUNT_OF_FRAMES_PER_ORDER;
    },
    [getCurrentFrameQuantity],
  );

  return {
    canAddFrames,
  };
};

export default useFrameQuantityLimit;
